import {CustomMessage} from "../../models/CustomMessage";


let customMessagesApi = {
    async get(token, companyId, page=1, filters){
        let response = await window.axios.get('/api/custom-messages', {
            params:{
                api_token:token,
                company_logged:companyId,
                page:page,
                ...filters
            }
        });

        let dataMap = data=>data.map(it=>new CustomMessage(it));
        if(response.data.current_page)
            response.data.data = dataMap(response.data.data);
        else
            response.data = dataMap(response.data);

        return response.data;
    },
    async create(customMessage, token, companyId){
        let response = await window.axios.post('/api/custom-messages', customMessage, {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });

        return new CustomMessage(response.data);
    },
    async find(id, token, companyId){
        let response = await window.axios.get('/api/custom-messages/'+id, {
            params:{
                api_token:token,
                company_logged:companyId
            }
        });
        return new CustomMessage(response.data);
    },
    async edit(customMessage, token, companyId){
        let response = await window.axios.put('/api/custom-messages/'+customMessage.id, customMessage, {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return new CustomMessage(response.data);
    },
    async delete(customMessage, token, companyId){
        let response = await window.axios.delete('/api/custom-messages/'+customMessage.id, {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return !!response.data.success;
    }
}

export default customMessagesApi